import { GridDisplaySettings } from '@app/models';
import { Action } from '@ngrx/store';
import { DataGridColumn } from 'ngrx-data-grid';

export interface InitGridDataPayload {
  data: object[];
  defaultColumns: DataGridColumn[];
  configuration?: GridDisplaySettings;
  actions?: Action[];
}

export enum InitGridActionTypes {
  InitDisplayGridWithData = '[InitGrid] Init display grid with data',
  InitSearchGridWithData = '[InitGrid] Init search grid with data'
}

export class InitDisplayGridWithData implements Action {
  readonly type = InitGridActionTypes.InitDisplayGridWithData;
  constructor(public payload: InitGridDataPayload) {
  }
}

export class InitSearchGridWithData implements Action {
  readonly type = InitGridActionTypes.InitSearchGridWithData;
  constructor(public payload: InitGridDataPayload) {
  }
}

export type InitGridActions =
  | InitDisplayGridWithData | InitSearchGridWithData;
